/**
 * Реквизиты оператора и сервиса. Используется в подвале, политике, согласиях.
 */
export const COMPANY = {
  legalName: "Общество с ограниченной ответственностью «Методология Предпринимательства»",
  shortName: "ООО «Методология Предпринимательства»",
  brand: "Hop.Agency",
  productName: "Hop · Diagnostic",
  address: "119234, г. Москва, ул. Ленинские Горы, д. 1, стр. 77, эт. 1, оф. 101",
  inn: "9729029163",
  kpp: "772901001",
  ogrn: "1167746914587",
  phone: "+7 495 364 04 16",
  email: "hello@hop.agency",
  website: "https://hop.agency",
  service: {
    domain: "startupscoring.ru",
    productEmail: "hello@hop.agency",
  },
  retentionMonths: 12,
};
